import { Button, Typography } from '@mui/material';
import { useState } from 'react';
import Popup from '/@/components/popup';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Input from '/@/v3/components/forms/input';
import styles from '/@/views/users/user-form/delete-account/styles.module.css';
import FinishDeleteAccount from '/@/views/users/user-form/finish-delete-account';
import deleteAccount from '../useDeleteAccount';

const INVALID_PASSWORD = 'Contraseña no válida';

const ConfirmDeleteAccount = ({ closePopup, user }) => {
    const [password, setPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState('');
    const [showPopupFinishDeleteAccount, setShowPopupFinishDeleteAccount] = useState(false);

    const handleDeleteAccount = async () => {
        if (password !== '' && password.length > 4) {
            if (
                await deleteAccount({
                    user,
                    password,
                    setErrorPassword,
                })
            ) {
                closePopup;
                setShowPopupFinishDeleteAccount(true);
            }
        } else {
            setShowPopupFinishDeleteAccount(false);
            setErrorPassword(INVALID_PASSWORD);
        }
    };

    return (
        <div className={styles.root}>
            <Typography
                variant='h3'
                color='primary'
                sx={{
                    mb: 3,
                    textAlign: 'center',
                    px: 2,
                    fontSize: (t) => t.typography.h3.fontSize,
                }}
            >
                {_('Ingresá tu contraseña para validar tu identidad')}
            </Typography>
            <Input
                iconPassword
                type='password'
                size='md'
                color={settings.app.theme}
                placeholder={_('Contraseña')}
                value={password}
                error={_(errorPassword)}
                onChange={setPassword}
                fullWidth
            />
            <Button variant='contained' onClick={handleDeleteAccount} fullWidth>
                {_('Confirmar')}
            </Button>
            <Button variant='outlined' onClick={closePopup} fullWidth>
                {_('Cancelar')}
            </Button>
            <Popup visible={showPopupFinishDeleteAccount}>
                <FinishDeleteAccount />
            </Popup>
        </div>
    );
};

export default ConfirmDeleteAccount;
